import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ICardComponentData, IEquipamento } from 'src/app/interfaces';
import { IToken } from 'src/app/interfaces/token/IToken';
import { ListaPaginada } from 'src/app/models';
import {
  AuthenticationService,
  ContratoService,
  EquipamentoService
} from 'src/app/services';

@Component({
  selector: 'app-listar-contrato-detalhes',
  templateUrl: './listar-contrato-detalhes.component.html',
  styleUrls: ['./listar-contrato-detalhes.component.scss']
})
export class ListarContratoDetalhesComponent implements OnInit, OnDestroy {
  subscriptions$ = new Subscription();
  exibirPaginacao: boolean;
  dadosCard: ICardComponentData[] = [];
  colunasVisiveis = [
    'modelo',
    'numPat',
    'numSerie',
    'temAcessorios',
    'temEquipamentoBackup',
    'dataInstalacao',
    'endereco',
    'nomeDepartamento'
  ];
  codContrato: string;
  token: IToken;
  equipamentos = new ListaPaginada<IEquipamento>();

  constructor(
    private authenticationService: AuthenticationService,
    private contratoService: ContratoService,
    private equipamentoService: EquipamentoService,
    private activatedRoute: ActivatedRoute
  ) {}

  obterEquipamentos(reiniciarPaginacao?: boolean) {
    if (reiniciarPaginacao) {
      this.equipamentos.paginaAtual = 1;
    }

    this.subscriptions$.add(
      this.equipamentoService
        .getEquipamentos({
          idUsuario: this.token.id,
          codContrato: [this.codContrato],
          codGrupoEconomico: this.token.codGrupoEconomico,
          tipoUsuario: this.token.tipoUsuario,
          itensPorPagina: this.equipamentos.itensPorPagina,
          paginaAtual: this.equipamentos.paginaAtual
        })
        .subscribe({
          next: ({ data, success }) => {
            this.equipamentos = data;
            this.exibirPaginacao = success;
          }
        })
    );
  }

  obterContrato() {
    this.subscriptions$.add(
      this.contratoService
        .getContratos({
          idUsuario: this.token.id,
          codContrato: [this.codContrato],
          codGrupoEconomico: this.token.codGrupoEconomico
        })
        .subscribe({
          next: ({
            data: {
              registros: [contrato]
            }
          }) => {
            this.dadosCard = [
              {
                title: 'Vendedor',
                value: contrato.nomeVendedor || 'Sem dados'
              },
              {
                title: 'Número do contrato',
                value: contrato.codContrato
              },
              {
                title: 'Cliente',
                value:
                  contrato.nomeFantasiaCliente ||
                  contrato.nomeCliente ||
                  'Sem dados'
              },
              {
                title: 'Multa contratual',
                value: ''
              },
              {
                title: 'SLA',
                value: ''
              },
              {
                title: 'Modelo de contrato',
                value: contrato.classificacaoContrato || 'Sem dados'
              }
            ];
          }
        })
    );
  }

  ngOnInit(): void {
    this.codContrato = this.activatedRoute.snapshot.params.codContrato;
    this.token = this.authenticationService.obterToken();
    this.obterEquipamentos();
    this.obterContrato();
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
